import appConfiguration from "@/components/cfg/AppCfg";
import { exportJobResponse, exportStatusResponse } from "@/schemas/exportData";
import {
  CONTENT_TYPE_MAP,
  ExportJobResponse,
  ExportStatusResponse,
} from "@/types/exportData";

class ExportDataService {
  async startExportData(
    moduleName: string,
    format: "csv" | "xlsx",
    params?: URLSearchParams,
  ): Promise<ExportJobResponse> {
    const exportUrl = new URL(
      `${appConfiguration.apiUrl}/${appConfiguration.apiVersion}/export-data/${moduleName}`,
    );

    if (params) {
      params.forEach((value, key) => {
        exportUrl.searchParams.append(key, value);
      });
    }

    const response = await fetch(exportUrl, {
      method: "POST",
      body: JSON.stringify({}),
      headers: { Accept: CONTENT_TYPE_MAP[format] },
    });

    if (!response.ok) {
      throw new Error("Failed to export data");
    }

    const data = await response.json();
    return exportJobResponse.parse(data);
  }

  async getExportStatus(
    moduleName: string,
    jobId: string,
  ): Promise<ExportStatusResponse> {
    const exportStatusUrl = new URL(
      `${appConfiguration.apiUrl}/${appConfiguration.apiVersion}/export-data/${moduleName}/status`,
    );

    exportStatusUrl.searchParams.append("job_id", jobId);

    const response = await fetch(exportStatusUrl);

    if (!response.ok) {
      throw new Error("Failed to get export status");
    }

    const responseData = await response.json();
    return exportStatusResponse.parse(responseData);
  }
}

export default new ExportDataService();
